import { TagRequest } from '~src/httpClient/TAG/TagRequest';

import { ITagResult } from '../../../../../httpClient/serverApi/types/IResponse';
import { IExtsvcServerSettings } from '../../../../ServerApi/types/IEditableServerSettings';

export interface IUpdateExtsvcServerSettingsParams {
  settings: IExtsvcServerSettings;
}

export type IUpdateExtsvcServerSettingsResult = ITagResult & IExtsvcServerSettings;

export class UpdateExtsvcServerSettingsRequest extends TagRequest<IExtsvcServerSettings, IUpdateExtsvcServerSettingsResult> {
  constructor(params: IExtsvcServerSettings) {
    super('analyticsextensions', 'updateAnalyticsExtensionsServerSettings', params);
  }
}
